/* eslint-disable no-const-assign */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-key */
import find from 'lodash/find';
import React, { useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  deleteMeasure,
  editMeasure,
  editedRow,
} from '../../actions';
import ModelCard from '../roomCardModel';
import DeleteRoomModal from '../roomCardModel/deleteModal';
import { updatePath } from '../../actions/pathActions';
import ConfirmationModal from '../confirmationModal';
import {
  roomMeasureSelector,
} from '../../selectors/roomMeasure';
import { trackEnterRoomsRemoveRoom } from '../../utils/analytics/trackEvents';


function Measures() {
  const { measure } = useSelector(roomMeasureSelector);

  const [showModal, setShowModal] = useState(false);
  const [toBeDeleted, setToBeDeleted] = useState('');
  const [roomNameTobedDleted, setRoomNameTobedDleted] = useState('');

  const dispatch = useDispatch();

  const cardRef = useRef({});

  const confirmDelete = () => {
    if (toBeDeleted !== '') {
      const { sqFt } = find(measure, (room) => room.id === toBeDeleted);
      trackEnterRoomsRemoveRoom(toBeDeleted, sqFt);
      dispatch(deleteMeasure(toBeDeleted));
      dispatch(updatePath());
    }
    setShowModal(false);
  };

  const deleteRow = (el, roomName) => {
    setToBeDeleted(el);
    setShowModal(true);
    setRoomNameTobedDleted(roomName);
  };

  const editRow = (el) => {
    if (el !== '') {
      dispatch(editMeasure(true));
      dispatch(editedRow(el));
    }
  };

  return (
    <>
      {measure.length ? measure.map((row, key) => (
        <ModelCard
          id={row.id}
          key={key}
          forwardedRef={cardRef}
          name={row.room}
          len={row.length}
          width={row.width}
          sqt={row.sqFt}
          editRoom={() => editRow(row.id)}
          deleteRoom={() => deleteRow(row.id, row.room)}
        />
      ))
        : null}
      {showModal && (
        <DeleteRoomModal
          showModal
          title="Delete Room"
          bodyText="Are you sure you want to delete"
          roonName={roomNameTobedDleted}
          onDismiss={() => setShowModal(false)}
          onConfirmation={() => confirmDelete()}
        />
      )}
    </>
  );
}

export default Measures;
